import httpClient from "./httpClient";
import { fetchAllPaged } from "./fetchAllPaged";

/** Catalog / read-only coupon APIs (engagement lives in coupon*Engagement* services). */

export const getAllCoupons = async () =>
  fetchAllPaged(httpClient, "/coupons/all", "coupons");

/** One page: `limit` default 100 (server), max 500. */
export const getCouponsPage = async (params = {}) => {
  const { data } = await httpClient.get("/coupons/all", { params });
  return {
    coupons: data.coupons || [],
    total: data.total ?? 0,
    limit: data.limit,
    skip: data.skip,
  };
};

export const getTrendingCoupons = async (limit = 12) => {
  const { data } = await httpClient.get("/coupons/trending", {
    params: { limit },
  });
  return data.coupons || [];
};

export const getCouponById = async (id) => {
  const { data } = await httpClient.get(`/coupons/${encodeURIComponent(id)}`);
  return data.coupon || null;
};

/** One page of category coupons (`limit` default 100, max 500). */
export const getCouponsCategoryPage = async (slug, params = {}) => {
  const { data } = await httpClient.get(
    `/coupons/category/${encodeURIComponent(slug)}`,
    { params }
  );
  return {
    coupons: data.coupons || [],
    total: data.total ?? 0,
    limit: data.limit,
    skip: data.skip,
  };
};

export const getCouponsForCategorySlug = async (slug) =>
  fetchAllPaged(
    httpClient,
    `/coupons/category/${encodeURIComponent(slug)}`,
    "coupons"
  );
